import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { HttpService } from "../../service/http.service";
import { getMessaging, onMessage } from "firebase/messaging";
import { CommonModule } from "@angular/common";
import { GlobalService } from "../../service/global.service";

@Component({
  selector: "app-active-call-chat-strip",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./active-call-chat-strip.component.html",
  styleUrl: "./active-call-chat-strip.component.scss",
})
export class ActiveCallChatStripComponent {
  callChatStatus: any = [];
  customerId: any;
  constructor(
    private _homeService: HttpService,
    private router: Router,
    public gS: GlobalService
  ) {
    this.listen();
    this.customerId = this.gS.userData?.id;
  }

  listen() {
    const messaging = getMessaging();
    onMessage(messaging, (payload: any) => {
      console.log("payload");

      if (payload?.data?.type == "chatPerMin_status_to_user") {
        this.checkRunningCallChatStatus();
      }
      console.log("Message received. in active-chat-window", payload);
    });
  }

  ngOnInit(): void {
    console.log("active call chat strip ngonint ");
    this.checkRunningCallChatStatus();
    setInterval(() => {
      this.checkRunningCallChatStatus();
    }, 30000);
  }

  checkRunningCallChatStatus() {
    console.log("this. charckRunning callchat status is called ");
    this.callChatStatus = [];
    this._homeService.checkRunningCallChat(this.customerId).subscribe(
      (data: any) => {
        console.log("check running callstatus data is comming", data);
        if (data?.data) {
          // let jsonData = parseJSON(value.data.token);
          // this.callChatStatus=parseJSON(value.data.token);
          let btnMessage = "Waiting";
          let btnChat = "";
          if (data?.data) {
            data?.data.forEach((value: any) => {
              let $showBtn = 0;

              if (
                value?.serviceStatus &&
                value?.serviceStatus == "IN_PROGRESS"
              ) {
                if (value?.serviceType == "CHAT") {
                  $showBtn = 1;

                  if (value?.orderStatus == "ASK") {
                    btnMessage = "Waiting";
                  }
                  if (value?.orderStatus == "ACCEPTED_BY_CONSULTANT") {
                    btnMessage = "Accept Chat";
                  }
                  if (value?.orderStatus == "INPROGRESS") {
                    btnMessage = "Chat";
                    btnChat =
                      ' <a href="javascript:void(0)" class="btndngr" data-name="" data-id="">' +
                      btnMessage +
                      "</a>";
                  }
                }
              }

              if (value?.serviceStatus && value?.serviceStatus == "WAITING") {
                btnMessage = "Cancel";
              }

              let objCustom = {
                showBtn: $showBtn,
                btnMessage: btnMessage,
                data: value,
              };
              this.callChatStatus.push(objCustom);
            });
          }

          console.log(this.callChatStatus, "objtoken");
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  chatNow(item: any) {
    console.log(item);
    this.router.navigate(["/chat-with-consultation"]);
  }

  cancelChatCall() {
    this._homeService.cancelChatCall(this.customerId).subscribe((data: any) => {
      if (data?.status == "success") {
        // location.reload();
        this.checkRunningCallChatStatus();
        this.router.navigate(["/chat-with-astrologer"]);
      }
    });
  }

  acceptChat(orderId: any) {
    this.checkRunningCallChatStatus();

    console.log(orderId?.data?.orderId);
    // return;
    this._homeService
      .userAstrologerChatAccept(orderId?.data?.orderId)
      .subscribe((data: any) => {
        if (data?.status == "success") {

          console.log('Data with accept Chat if success');
          // location.reload();
          // this.router.navigate(["/chat-with-consultation"], {
          //   state: { orderId: orderId?.data?.orderId , astrologerId: orderId?.data?.astrologerId},
          // });
        } else if (data?.reason == "INPROGRESS") {
          console.log('Data with accept Chat if inprogress');
          this.router.navigate(["/chat-with-consultation"], {
            queryParams: { orderId: orderId?.data?.orderId , astrologerId: orderId?.data?.astrologerId},
          });
        }
      });
  }
}
